import { Typography } from '@mui/material';
import Box from '@mui/material/Box';
import { FormattedMessage } from 'react-intl';
import { useRecoilValue } from 'recoil';
import ModelDetails from '~/components/ModelDetails';
import { currentDoseState, DoseData } from '~/state/atoms/dose/doseAtoms';
import DoseTargets from './Targets';

export default function DoseDetails({ dose }: { dose: DoseData }) {
    const currentDose = useRecoilValue(currentDoseState);
    const selectedTargets = dose?.targets
        ?.filter((target) => target.isTarget)
        .map(({ name, doseQuantity }) => ({
            targetName: name,
            doseQuantity,
        }));

    return (
        <Box display="grid">
            <Box display={'flex'} justifyContent="space-between" gap={0.5}>
                {dose?.generated ? (
                    <Box>
                        <Typography fontSize={12} textTransform="capitalize">
                            <FormattedMessage id="predicted" />
                        </Typography>
                    </Box>
                ) : (
                    <Typography fontSize={12}>{dose?.type}</Typography>
                )}
            </Box>

            <ModelDetails generationModel={currentDose?.generationModel} />
            {selectedTargets && <DoseTargets data={selectedTargets} />}
        </Box>
    );
}
